<template>
    <div class="sc-typing-indicator">
        <span />
        <span />
        <span />
    </div>
</template>
<script>
export default {
    props: {
        messageColors: {
            type: Object,
            required: true,
        },
    },
};
</script>
<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

.sc-typing-indicator {
    align-items: center;
    background: $grey-lighter;
    border-radius: $radius-large;
    display: flex;
    height: 2.9rem;
    padding: $size-10 $size-8;
    text-align: center;
}

.sc-typing-indicator span {
    display: inline-block;
    background-color: $grey-lighter;
    width: 7px;
    height: 7px;
    border-radius: 100%;
    margin-right: 3px;
    animation: bob 2s infinite;

    &:last-child {
        margin-right: 0;
    }
}

/* SAFARI GLITCH */
.sc-typing-indicator span:nth-child(1) {
    animation-delay: -1s;
}
.sc-typing-indicator span:nth-child(2) {
    animation-delay: -0.85s;
}
.sc-typing-indicator span:nth-child(3) {
    animation-delay: -0.7s;
}

@keyframes bob {
    10% {
        transform: translateY(-10px);
        background-color: $text;
    }
    50% {
        transform: translateY(0);
        background-color: $grey;
    }
}
</style>
